export function capitalise(str?: string): string {
  if (!str || typeof str !== "string") return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const HTML_TAG_REGEX = /<[^>]*>/g;

export const containsHtmlLikeTags = (value?: string | null) => {
  if (!value) return false;
  HTML_TAG_REGEX.lastIndex = 0;
  return HTML_TAG_REGEX.test(value);
};

export const stripHtmlTags = (value?: string | null) => {
  if (!value) return "";
  HTML_TAG_REGEX.lastIndex = 0;
  return value.replace(HTML_TAG_REGEX, "");
};

export const buildName = (names: string[]) => {
  return names.reduce((fullName, name) => {
    if (name) {
      return `${fullName} ${name}`;
    }
    return fullName;
  });
};
